import React, { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/core/styles";


pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const useStyles = makeStyles(() => ({
  volunteerIntro: {
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto',
    padding: '1rem',
    color: '#15678D',
    fontWeight: 200,
    fontFamily: 'Arial, Helvetica, sans-serif',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '& h2': {
      fontSize: '2rem',
      marginBottom: '1rem',
    },
    '& p': {
      fontSize: '1rem',
      lineHeight: '1.6rem',
    },

    '@media screen and (max-width: 700px)': {
      '& h2': {
        fontSize: '1.25rem',
      },
      '& p': {
        fontSize: '0.95rem',
        lineHeight: '1.5rem',
      },
    },
  },

  pdfWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: '1rem',
  },

  announcement: {
    color: '#b00000',
    padding: '1rem',
    fontWeight: 'bold',
    fontSize: '1.2rem',
    textAlign: 'center',
    margin: '1rem auto',
    maxWidth: '800px',
    backgroundColor: 'transparent',
  },
  icon: {
    fontSize: '2rem',
    margin: '1rem 0',
    color: '#fff',
    textShadow: '0px 1px 3px black',
  },
  iconSmall: {
    fontSize: '1.5rem',
    margin: '1rem',
    color: '#fff',
    textShadow: '0px 1px 3px black',
  },
}));

const Volunteer = () => {
  const [numPages, setNumPages] = useState(null);
  const [pdfWidth, setPdfWidth] = useState(800);
  const classes = useStyles();

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      setPdfWidth(screenWidth < 900 ? screenWidth - 32 : 800);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <div>
      <br />
      <br />
      <br />

      <div className={classes.announcement}>
  <i className="fas fa-exclamation-circle" style={{ marginRight: '0.5rem', color: '#b00000' }}></i>
  Thank you for your interest in the Summer 2025 Volunteer & Internship Program. The application period is now closed. Please stay connected for future opportunities.
</div>

      <div className={classes.volunteerIntro}>
        <h2>Volunteer & Internship Opportunities – Summer 2025</h2>
        <br />
        <p>
          Learn about available roles, how to apply, and key deadlines in our 2025 Summer Program.
          <br />
          <strong>Ready to get involved?</strong> Send your resume or contact us with any questions!
        </p>
      </div>

      <div className={classes.pdfWrapper}>
        <Document file="/documents/Volunteer2025.pdf" onLoadSuccess={onDocumentLoadSuccess}>
          {Array.from({ length: numPages }, (_, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              width={pdfWidth}
            />
          ))}
        </Document>
      </div>
    </div>
  );
};

export default Volunteer;
